import React, { useState } from 'react'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { removeErrorDisplay } from '../../_functions'

const createOption = (label) => ({
  label,
  value: label,
})

export const pageViewComparationOptions = [
  { label: "Igual a", value: "==" },
  { label: "Diferente de", value: "!=" },
  { label: "Contém", value: "contain" },
  { label: "Não contém", value: "notcontain" }
]

export default function Pageview( { disabled, ...props } ) {
  const [ inputError, setInputError ] = useState({filter: false, condition: false, value: false})
  const [ selectedValues, setSelectedValues ] = useState({inputValue: "", value: []})

  const handleChange = (e, type) => {
    removeErrorDisplay(type, props.errors, props.setErrors)

    const raw = `raw_${type}`
    type = type.split('_')[1]
    const arr = props.localData.trigger ? props.localData.trigger : []
    props.setLocalData({...props.localData, trigger: {...arr, [type]: e.value}, [raw]: e})
  }

  const handleInputChange = inputValue => setSelectedValues({...selectedValues, inputValue})
  
  const handleChangeValue = (e, type) => {
    removeErrorDisplay(type, props.errors, props.setErrors)

    let arr = props.localData.trigger ? props.localData.trigger : []
    
    const raw = `raw_${type}`
    if ( !e || !type ) {
      delete arr.value
      return props.setLocalData({...props.localData, trigger: arr, [raw]: []})
    }

    const { value } = e
    setSelectedValues({...selectedValues, value})

    if ( e.value && e.value.length !== 0 ) {
      arr.value = []

      value.map(item => {
        arr.value.push(item.value)
      })
      return props.setLocalData({...props.localData, trigger: arr, [raw]: e.value})
    }

    arr.value = []
    e.map(item => {
      arr.value.push(item.value)
    })

    props.setLocalData({...props.localData, trigger: arr, [raw]: arr.value.length === 2 ? arr.value.join(' e ') : arr.value.join(', ')})
  }

  // useEffect( () => {}, [] )

  const handleKeyDown = (event, type) => {
    removeErrorDisplay(type, props.errors, props.setErrors)

    const { key, nativeEvent } = event
    const { inputValue, value } = selectedValues
    if ( !inputValue ) return

    setInputError({...inputError, value: false})

    const raw = `raw_${type}`

    switch ( key ) {
      case "":
      case "Enter":
      case "Tab":
      case "Blur":
        event.preventDefault()

        setSelectedValues({
          inputValue: "",
          value: (value && value.length !== 0) ? [...value, createOption(inputValue)] : [createOption(inputValue)]
        })

        const arr = props.localData.trigger ? props.localData.trigger : []
        if ( !arr.value ) arr.value = []
        arr.value.push(inputValue)
        
        props.setLocalData({...props.localData, trigger: arr, [raw]: arr.value.length === 2 ? arr.value.join(' e ') : arr.value.join(', ')})
      break
      default: break
    }
  }

  return (
    <>
      <Select
        options={pageViewComparationOptions}
        value={props.localData.raw_trigger_comparation}
        className={`
          selectable
          ${props.errors.triggerComparation && "selectable--error"}
        `}
        isDisabled={disabled}
        placeholder="Selecione a condição"
        onChange={(e) => handleChange(e, "trigger_comparation")}
      />
      <CreatableSelect
        className={`
          selectable
          ${props.errors.triggerValue && "selectable--error"}
          ${props.errors.triggerValue === "urlError" && "selectable--error selectable--error-url"}
        `}
        value={props.localData.trigger.value?.map( value => ( { label: value, value } ) ) ?? []}
        components={{DropdownIndicator: null}}
        inputValue={selectedValues.inputValue}
        isDisabled={disabled}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(e) => handleChangeValue(e, "trigger_value")}
        onInputChange={(e) => handleInputChange(e, "trigger_value")}
        onKeyDown={(e) => handleKeyDown(e, "trigger_value")}
        placeholder="Defina as URLs"
      />
      {
        inputError.value ?
          <p className="input__text--error">Informe uma URL válida. (Ex.: https://site.com)</p>
        : null
      }
    </>
  )
}